import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RecommendedArticlesService {
  private API_URL = environment.API_URL;

  constructor(private http: HttpClient) {}

  getRecommendedArticles(currentArticleId: number): Observable<any[]> {
    const url = `${this.API_URL}/blog-posts?populate=*&sort=publishedAt:desc`;

    return this.http.get<any>(url, {
      headers: { Authorization: `Bearer ${environment.API_TOKEN}` }
    }).pipe(
      map((res: any) => {
        const allPosts = res.data;
        const currentPost = allPosts.find((p: any) => p.id === currentArticleId);
        if (!currentPost) return [];

        const currentTags = currentPost.attributes.post_tags.data.map((tag: any) => tag.id);

        return allPosts
          .filter((post: any) => {
            if (post.id === currentArticleId) return false;
            const tags = post.attributes.post_tags.data.map((tag: any) => tag.id);
            return tags.some((tagId: number) => currentTags.includes(tagId));
          })
          .slice(0, 3);
      })
    );
  }
}
